<eds-checkbox
  class="checkbox-cell-renderer"
  [hideLabel]="true"
  [inline]="true"
  [id]="cellId"
  [value]="!!cellValue"
  [checked]="!!cellValue"
  (checkedChange)="checkboxChanged($event)"
></eds-checkbox>
